
import { Component, Prop, Emit, Vue } from 'vue-property-decorator'

@Component
export default class Informer extends Vue {
  @Prop() readonly message: string;

  @Emit('cancel')
  cancel(): void {
    return;
  }
}
